// extracted by mini-css-extract-plugin
export default {"cardsContainer":"YrLOZjzzIOct9x7EbKGi","card":"r2jf0CHjODE_eUBffcgn","cardContent":"Izns_VfVFIHwIUzRtYgt","cardIcon":"C8hvQstphZk9ZqPuZgaP"};